import { SuppressKeyboardEventParams } from "@ag-grid-community/core";
import { last } from "lodash-es";
import { isInputElement } from "shared/utils/DomUtils";

export const maybernTableSuppressKeyboardEventForInput = ({
  event,
}: SuppressKeyboardEventParams) => {
  const el = document.activeElement;
  const cellEl = el?.closest(".ag-cell");

  const selectEl = cellEl?.querySelector(".react-select__control");
  const isSelectWithOpenMenu = Boolean(
    selectEl?.classList.contains("react-select__control--menu-is-open"),
  );

  const focusableEls = [
    ...(cellEl?.querySelectorAll("input, button").values() ?? []),
  ].filter((e) => {
    const tabIndex = e.getAttribute("tabIndex");
    return tabIndex && tabIndex !== "-1" && e.checkVisibility();
  });
  const hasNextFocusableEl =
    focusableEls.length > 1 && last(focusableEls) !== el;

  return (
    isSelectWithOpenMenu ||
    (hasNextFocusableEl && event.key === "Tab") ||
    (isInputElement(el) &&
      el.getAttribute("type") !== "checkbox" &&
      !el.disabled &&
      !el.readOnly &&
      // allow text operations within input, e.g.
      // select all (⌘+A), cut (⌘+C), copy (⌘+X), paste (⌘+V), etc.
      (event.metaKey ||
        // allow arrow keys to move cursor within the input
        (event.key === "ArrowLeft" && (el.selectionStart ?? 0) > 0) ||
        (event.key === "ArrowRight" &&
          (el.selectionStart ?? 0) < el.value.length)))
  );
};
